import React from 'react';

export default function RadarAtividadesPage() {
  return (
    <div>
      Qualidade - Radar de Atividades (placeholder).
    </div>
  );
}

